<form class="fn-ui-datetime-picker" [formGroup]="form">
  <gpp-ui-form-canvas [classList]="'form-root'"
                      [form]="form"
                      [userPreferences]="userPreferences"
                      [controlsMetadata]="formMetadata"
                      [isRoot]="true"
                      [fieldAppearance]="appearance"
                      [fieldLabelFloat]="floatLabel">
  </gpp-ui-form-canvas>
</form>